export function getFrontendURLRegion() {
  const frontendURL = import.meta.env.VITE_FRONTEND_URL ?? '';
  switch (frontendURL) {
    case 'https://staging.wexler.ai':
      return 'staging';
    case 'https://au.wexler.ai':
      return 'au';
    case 'https://us.wexler.ai':
      return 'us';
    case 'https://app.wexler.ai':
      return 'uk';
    default:
      return 'staging';
  }
}
